import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With a distinguished track record across several leading cooperative insurance
                companies, your approach to enterprise risk management has shaped how these
                organizations navigate uncertainty. As Chief Risk Officer at SALAMA Cooperative
                Insurance, how do you structure a resilient risk framework that balances regulatory
                compliance with strategic agility in a constantly evolving industry?
              </strong>
            </h5>

            <h5 className="text-white">
              Given my experience across several companies, each with its own distinct risk culture,
              I would structure a resilient risk framework by:
              <br />
              <ul>
                <li>
                  Embedding risk management & BCM into strategy with clearly defined risk appetite
                  and tolerance levels.
                </li>
                <li>
                  Implementing a robust Three Lines of Defense model by enhancing the Building of
                  Risk Culture.
                </li>
                <li>
                  Conducting regular and comprehensive business impact analyses, risk assessments,
                  encompassing both qualitative and quantitative analyses, and including the
                  identification of emerging risks.
                </li>
                <li>Developing suitable and effective mitigation and control plans.</li>
                <li>
                  Establishing dynamic risk monitoring and reporting mechanisms, utilizing Key Risk
                  Indicators (KRIs) and stress testing methodologies implemented in various ways.
                </li>
                <li>
                  Proactively engaging with regulatory bodies (Insurance Authority in Saudi Arabia)
                  and building a flexible framework that can adapt to change.
                </li>
                <li>
                  Fostering a strong risk culture throughout the organization through comprehensive
                  training and open communication channels.
                </li>
                <li>Striving to establish a sustainable risk management framework.</li>
              </ul>
              <br />
              The overarching goal is to integrate risk management as a strategic enabler, ensuring
              full regulatory compliance while promoting agile decision-making within our evolving
              industry.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Your experience spans internal audit, fraud prevention, and business
                continuity—critical areas that converge in today’s risk landscape. What are the most
                pressing risk challenges currently facing the insurance sector in the region, and
                how can companies’ future-proof themselves through proactive risk culture and
                integrated compliance strategies?
              </strong>
            </h5>
            <h5 className="text-white">
              Pressing regional insurance risks include:
              <ul>
                <li>Cyber threats: Increasing sophistication and impact.</li>
                <li>Regulatory evolution: Faster pace and complexity.</li>
                <li>
                  Customer expectations: Demanding digital experiences and personalized service.
                </li>
                <li>
                  Customer behavior: Including fraudulent activities often conducted in good faith
                  due to a lack of awareness of regulations.
                </li>
              </ul>
              <br />
              Futureproofing requires:
              <ul>
                <li>
                  Proactive risk culture: Embedding awareness and accountability across all levels.
                </li>
                <li>
                  Integrated compliance: Anticipating changes and using technology for robust
                  monitoring.
                </li>
                <li>
                  Expanding Business Continuity Management (BCM): Developing and adaptable BCM plans
                  that can effectively address a wider range of potential disruptions arising from
                  the identified risks, ensuring operational resilience.
                </li>
              </ul>
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q- You've led risk functions during times of increasing regulatory oversight and
                market disruption. How do you ensure that risk management remains not just a
                safeguard function but a strategic enabler within the executive decision-making
                process?
              </strong>
            </h5>
            <h5 className="text-white">
              To make risk a strategic helper in big decisions, not just the 'don't do that' team, I
              focus on:
              <ul>
                <li>
                  Being in the Key Meetings: Risk insights are part of executive discussions from
                  the start.
                </li>
                <li>
                  Talking Business: Framing risks in terms of profit, opportunities, and goals, not
                  just rules.
                </li>
                <li>
                  Looking Ahead: Providing early warnings and future scenarios to inform strategy.
                </li>
                <li>
                  Risk-Smart Decisions: Factoring risk into how we measure success and invest.
                </li>
                <li>Building Trust: Making risk a partner in reaching goals, not a roadblock.</li>
                <li>
                  Showing the Benefits: Demonstrating how good risk management boosts profit and
                  success."
                </li>
              </ul>
              <br />
              In short just Linking the Risk with Opportunities and rewords.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Certifications in ISO standards and financial crime prevention add a layer of
                global best practice to your leadership. How do you incorporate international
                standards into local regulatory frameworks, and what role do these certifications
                play in elevating organizational credibility and resilience?
              </strong>
            </h5>
            <h5 className="text-white">
              Our local regulations are 80-95% aligned with international standards. I recommend a
              tailored approach: blending ISO & COSO with local rules for a custom risk system.
              Incorporating international standards:
              <ul>
                <li>Leverage overlap: Build on the existing # 80-95% alignment.</li>
                <li>
                  Adopt stronger elements: Selectively integrate the international practices (e.g.,
                  ISO 31000 risk assessment, COSO internal controls).
                </li>
                <li>Customize for us: Tailor the combined framework to our specific needs.</li>
              </ul>
              <br />
              Certifications (ISO, financial crime and more) boost credibility and resilience by:
              <ul>
                <li>Demonstrating global best practice commitment.</li>
                <li>Strengthening risk management and financial crime prevention.</li>
                <li>Facilitating local compliance.</li>
                <li>Enhancing stakeholder trust and attracting partners/talent.</li>
              </ul>
              This blended approach creates a strong, credible, and resilient risk system relevant
              to our local context.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Having served as CRO in multiple insurance firms, you bring a comparative view of
                risk cultures and governance models. What are the key success factors for building a
                strong, enterprise-wide risk culture, and how do you embed accountability and
                awareness at every level of the organization?
              </strong>
            </h5>
            <h5 className="text-white">
              Building a strong risk culture requires Leadership Commitment & Clear Communication &
              ongoing Training. To embed accountability and awareness, we first assess our risk
              culture's maturity based on:
              <br />
              <ul>
                <li>Policies: Clarity and application.</li>
                <li>Processes: Risk consideration in design.</li>
                <li>Systems & Data: Accurate risk information.</li>
                <li>People & Structure: Defined roles and expertise.</li>
                <li>Reporting: Effective communication.</li>
              </ul>
              <br />
              Then, we:
              <br />
              <ul>
                <li>Define Clear Roles: risk ownership for everyone.</li>
                <li>Targeted Training: Role-specific risk education.</li>
                <li>Empower Champions: Local risk mindsets.</li>
                <li>Integrate into Performance: Link risk to evaluations.</li>
                <li>Regularly Communicate: Share risk performance broadly.</li>
              </ul>
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
